<template>
  <div
    class="mt-0 mt-sm-5 mt-md-0"
    v-if="appParams && appParams.staticTranslations"
  >
    <section class="itb-hero-cards-contact">
      <div class="container">
        <div
          class="row d-flex align-content-center mx-0 itb-bg itb-lazy-loading-bg"
          v-lazy:background-image="'/images/articles/contact-main.webp'"
        >
          <div class="col-12 col-md-8 offset-md-4 col-xl-6 offset-xl-6 p-0">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <h2>
                      {{ appParams.general_company_name }}
                    </h2>
                    <p class="m-0">
                      {{ appParams.general_company_street }}
                    </p>
                    <p class="m-0">
                      {{ appParams.general_company_city }}
                    </p>
                    <p class="m-0" v-if="appParams.general_company_country">
                      {{ appParams.general_company_country }}
                    </p>
                    <p style="margin-bottom: 1.3rem">
                      {{ appParams.staticTranslations["contacts.ico"] }}:
                      {{ appParams.general_company_ico }}
                    </p>
                    <p>
                      {{ appParams.staticTranslations["contacts.dic"] }}:
                      {{ appParams.general_company_dic }}
                      {{
                        appParams.staticTranslations[
                          "contacts.we_are_tax_payers"
                        ]
                      }}
                    </p>
                    <p class="m-0 itb-info" style="margin-bottom: 1rem">
                      {{ appParams.general_company_dic_text }}
                    </p>
                  </div>
                  <div class="col-12 col-md-6 pl-xl-0">
                    <h3>
                      {{ appParams.staticTranslations["contacts.bank_info"] }}
                    </h3>
                    <p style="margin-bottom: 1.3rem">
                      {{ appParams.general_company_bank_account }},
                      <br />
                      {{ appParams.general_bank_acount_text }}
                    </p>
                    <p class="itb-info" style="margin-bottom: 2.2rem">
                      {{ appParams.staticTranslations["contacts.swift"] }}:
                      {{ appParams.general_swift }}
                      <br />
                      {{ appParams.staticTranslations["contacts.iban"] }}:
                      {{ appParams.general_iban }}
                    </p>
                    <h3>
                      {{
                        appParams.staticTranslations["contacts.contact_info"]
                      }}
                    </h3>
                    <p class="m-0">
                      <a
                        :href="'tel:' + stripedPhone(appParams.general_phone)"
                        itemprop="telephone"
                        >{{ appParams.general_phone }}</a
                      >
                    </p>
                    <p class="m-0">
                      <a
                        :href="
                          'mailto:' +
                          appParams.general_email +
                          '?Subject=' +
                          appParams.staticTranslations['general.email_subject']
                        "
                        itemprop="email"
                        >{{ appParams.general_email }}</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="contacts[3]"
      class="itb-contacts-section"
      id="itb-contacts-first-section"
    >
      <div class="container">
        <h2 class="text-center">
          {{ appParams.staticTranslations["contacts.office"] }}
        </h2>
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 d-flex"
            v-for="contact in contacts[3]"
          >
            <div
              class="card w-100"
              :class="{
                'itb-contact-with-no-map': !contact.user.imageMap,
                'itb-contact-with-map': !!contact.user.imageMap,
              }"
              v-lazy-container="{ selector: '.itb-lazy' }"
            >
              <img
                v-if="contact.user.imageMap"
                :data-src="
                  '/uploads/' +
                  contact.user.imageMap.path +
                  '/' +
                  contact.user.imageMap.name
                "
                :alt="appParams.staticTranslations['contacts.map']"
                class="itb-map itb-lazy"
              />
              <div class="card-body">
                <div class="row">
                  <div v-if="contact.user.image" class="col-12 col-sm-4">
                    <img
                      :data-src="
                        '/uploads/' +
                        contact.user.image.path +
                        '/' +
                        contact.user.image.name
                      "
                      :alt="contact.user.name"
                      class="itb-lazy"
                    />
                  </div>
                  <div class="col-12 col-sm-8 itb-right-col pr-0">
                    <h3>{{ contact.user.name }}</h3>
                    <p class="m-0">
                      <a
                        :href="'tel:' + stripedPhone(contact.user.phone)"
                        itemprop="telephone"
                        >{{ contact.user.phone }}</a
                      >
                    </p>
                    <p class="itb-email">
                      <a
                        :href="
                          'mailto:' +
                          contact.user.email +
                          '?Subject=' +
                          appParams.staticTranslations['general.email_subject']
                        "
                        itemprop="email"
                        >{{ contact.user.email }}</a
                      >
                    </p>
                    <p class="itb-regions">
                      <span>{{
                        contact.user["role_" + currentLanguage]
                          ? contact.user["role_" + currentLanguage]
                          : ""
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="contacts[1]"
      class="itb-contacts-section"
      id="itb-contacts-first-section"
    >
      <div class="container">
        <h2 class="text-center">
          {{ appParams.staticTranslations["contacts.world"] }}
        </h2>
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 d-flex"
            v-for="contact in contacts[1]"
          >
            <div
              class="card w-100"
              :class="{
                'itb-contact-with-no-map': !contact.user.imageMap,
                'itb-contact-with-map': !!contact.user.imageMap,
              }"
              v-lazy-container="{ selector: '.itb-lazy' }"
            >
              <img
                v-if="contact.user.imageMap"
                :data-src="
                  '/uploads/' +
                  contact.user.imageMap.path +
                  '/' +
                  contact.user.imageMap.name
                "
                :alt="appParams.staticTranslations['contacts.map']"
                class="itb-map itb-lazy"
              />
              <div class="card-body">
                <div class="row">
                  <div v-if="contact.user.image" class="col-12 col-sm-4">
                    <img
                      :data-src="
                        '/uploads/' +
                        contact.user.image.path +
                        '/' +
                        contact.user.image.name
                      "
                      :alt="contact.user.name"
                      class="itb-lazy"
                    />
                  </div>
                  <div class="col-12 col-sm-8 itb-right-col pr-0">
                    <h3>{{ contact.user.name }}</h3>
                    <p class="m-0">
                      <a
                        :href="'tel:' + stripedPhone(contact.user.phone)"
                        itemprop="telephone"
                        >{{ contact.user.phone }}</a
                      >
                    </p>
                    <p class="itb-email">
                      <a
                        :href="
                          'mailto:' +
                          contact.user.email +
                          '?Subject=' +
                          appParams.staticTranslations['general.email_subject']
                        "
                        itemprop="email"
                        >{{ contact.user.email }}</a
                      >
                    </p>
                    <p class="itb-regions">
                      <span>{{
                        contact.user["role_" + currentLanguage]
                          ? contact.user["role_" + currentLanguage]
                          : ""
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="contacts[2]"
      class="itb-contacts-section"
      id="itb-contacts-first-section"
    >
      <div class="container">
        <h2 class="text-center">
          {{ appParams.staticTranslations["contacts.other_category"] }}
        </h2>
        <div class="row">
          <div
            class="col-12 col-md-6 col-lg-4 d-flex"
            v-for="contact in contacts[2]"
          >
            <div
              class="card w-100"
              :class="{
                'itb-contact-with-no-map': !contact.user.imageMap,
                'itb-contact-with-map': !!contact.user.imageMap,
              }"
              v-lazy-container="{ selector: '.itb-lazy' }"
            >
              <img
                v-if="contact.user.imageMap"
                :data-src="
                  '/uploads/' +
                  contact.user.imageMap.path +
                  '/' +
                  contact.user.imageMap.name
                "
                :alt="appParams.staticTranslations['contacts.map']"
                class="itb-map itb-lazy"
              />
              <div class="card-body">
                <div class="row">
                  <div v-if="contact.user.image" class="col-12 col-sm-4">
                    <img
                      :data-src="
                        '/uploads/' +
                        contact.user.image.path +
                        '/' +
                        contact.user.image.name
                      "
                      :alt="contact.user.name"
                      class="itb-lazy"
                    />
                  </div>
                  <div class="col-12 col-sm-8 itb-right-col pr-0">
                    <h3>{{ contact.user.name }}</h3>
                    <p class="m-0">
                      <a
                        :href="'tel:' + stripedPhone(contact.user.phone)"
                        itemprop="telephone"
                        >{{ contact.user.phone }}</a
                      >
                    </p>
                    <p class="itb-email">
                      <a
                        :href="
                          'mailto:' +
                          contact.user.email +
                          '?Subject=' +
                          appParams.staticTranslations['general.email_subject']
                        "
                        itemprop="email"
                        >{{ contact.user.email }}</a
                      >
                    </p>
                    <p class="itb-regions">
                      <span>{{
                        contact.user["role_" + currentLanguage]
                          ? contact.user["role_" + currentLanguage]
                          : ""
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      contacts: [],
      pageParams: [],
    };
  },

  mounted() {
    axios
      .get("/getContactPage")
      .then((response) => {
        this.contacts = response.data.contacts;
        this.pageParams = response.data.params;
        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
    }),

    currentLanguage() {
      return this.$store.state.domainLanguage;
    },
  },

  methods: {
    ...mapActions(["setPageParams"]),

    stripedPhone(phone) {
      return phone ? String(phone).replace(/\s/g, "") : "";
    },
  },
};
</script>
